import { type ButtonHTMLAttributes, type ReactNode } from 'react'
import styles from './Button.module.css'

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'destructive'
type ButtonSize = 'compact' | 'default'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  fullWidth?: boolean
  icon?: ReactNode
  mobileFullWidth?: boolean
  size?: ButtonSize
  variant?: ButtonVariant
}

export const Button = ({
  children,
  className,
  fullWidth = false,
  icon,
  mobileFullWidth = false,
  size = 'default',
  type = 'button',
  variant = 'secondary',
  ...props
}: ButtonProps) => (
  <button
    className={[
      styles.button,
      styles[variant],
      styles[size],
      fullWidth ? styles.fullWidth : '',
      mobileFullWidth ? styles.mobileFullWidth : '',
      className
    ].filter(Boolean).join(' ')}
    type={type}
    {...props}
  >
    {icon}
    {children}
  </button>
)
